import { render, staticRenderFns } from "./BillingClinicInformation.vue?vue&type=template&id=6499a186"
import script from "./BillingClinicInformation.vue?vue&type=script&lang=js"
export * from "./BillingClinicInformation.vue?vue&type=script&lang=js"
import style0 from "./BillingClinicInformation.vue?vue&type=style&index=0&id=6499a186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports